var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRoutes
        ? _c(
            "box",
            {
              attrs: {
                background: "white",
                "custom-class": "expansion-box",
                "no-shadow": ""
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("routeDetails.legend")))]),
                _vm._v(" "),
                _c("div", { staticClass: "legend" }, [
                  _c("div", { staticClass: "flex-row" }, [
                    _c("span", {
                      staticClass: "legend-box",
                      style: {
                        backgroundColor: _vm.orsDictionary.colors.csv[0]
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("routeDetails.legendLow")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-row" }, [
                    _c("span", {
                      staticClass: "legend-box",
                      style: {
                        backgroundColor: _vm.orsDictionary.colors.csv[1]
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("routeDetails.legendMid")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-row" }, [
                    _c("span", {
                      staticClass: "legend-box",
                      style: {
                        backgroundColor: _vm.orsDictionary.colors.csv[2]
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("routeDetails.legendHigh")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.hasRoutes
                ? _c(
                    "v-expansion-panel",
                    {
                      staticClass: "no-shadow",
                      attrs: {
                        slot: "content",
                        expand: "",
                        value: _vm.parsedRoutes.map(function(_, index) {
                          return index + 1
                        })
                      },
                      slot: "content"
                    },
                    _vm._l(_vm.parsedRoutes, function(route, routeIndex) {
                      return _c(
                        "v-expansion-panel-content",
                        {
                          key: routeIndex,
                          staticClass: "routes-header",
                          staticStyle: { background: "transparent" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "space-between"
                              },
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(
                                    routeIndex === 0
                                      ? _vm.$t("routeDetails.heatRoute")
                                      : _vm.$t("routeDetails.fastestRoute")
                                  ) +
                                    "\n            (" +
                                    _vm._s(route.summary.distance) +
                                    ")"
                                )
                              ]),
                              _vm._v(" "),
                              _vm.parsedRoutes.length > 1
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        title:
                                          routeIndex ===
                                          _vm.$store.getters.activeRouteIndex
                                            ? _vm.$t(
                                                "routeDetails.selectedRoute"
                                              )
                                            : _vm.$t("routeDetails.selectRoute")
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color:
                                              routeIndex ===
                                              _vm.$store.getters
                                                .activeRouteIndex
                                                ? "dark"
                                                : "grey lighten-1"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.changeActiveRouteIndex(
                                                routeIndex
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              routeIndex ===
                                                _vm.$store.getters
                                                  .activeRouteIndex
                                                ? "visibility"
                                                : "visibility_off"
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  staticClass: "route-details",
                                  attrs: { dense: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { padding: "0 0 0 10px" } },
                                    [
                                      route.summary.duration
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.duration")
                                              ) + ":  "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(route.summary.duration) +
                                                  " "
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("route-extras", {
                                    attrs: { route: route, idx: routeIndex }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d269ae30", { render: render, staticRenderFns: staticRenderFns })
  }
}